
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openai-api-playground-ui",
      function () {
        return require("private-next-pages/openai-api-playground-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openai-api-playground-ui"])
      });
    }
  